const storeDecorate = resolve =>
  require(['@/components/storeManager/storeDecorate/index.vue'], resolve)
  const storeinfor = resolve =>
  require(["@/components/systemmanagement/storeinfor/index.vue"], resolve);
const renovation = resolve =>
  require(['@/components/storeManager/storeDecorate/renovation/index.vue'], resolve)
const preview = resolve =>
  require(['@/components/storeManager/storeDecorate/renovation/preview.vue'], resolve)
export default [{
  path: '/homeMain/storemanager/storedecorate',
  component: storeDecorate
},{
  path: "/homeMain/systemmanagement/storeinfor",
  component: storeinfor
},{
  path: "/renovation/:channelId",
  component: renovation
},{
  path: "/preview/:channelId",
  component: preview
}]



// WEBPACK FOOTER //
// ./src/router/storeManager.js